export default "__VITE_ASSET__DrHttRPx__"